import React from 'react';
import { SortButton } from '../../../../search/components/sort';
import { SearchProps } from '../../models/arc-epi-props';

interface DioceseInstitutionListLabelsProps {
	settings: SearchProps,
}

export function DioceseInstitutionListLabels(props: DioceseInstitutionListLabelsProps){

	return (
		<div className='sort-table-row'>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.institutionIdLabel} name='client_number' />
			</div>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.institutionNameLabel} name='organization_name' />
			</div>
			
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.institutionCityLabel} name='city' />
			</div>
			<div className='sort-table-row-cell'>
				<p><strong>{props.settings?.institutionStatusLabel}</strong></p>
			</div>
		</div>
	);
}